// removed by extract-text-webpack-plugin
module.exports = {"Footer":"Footer__Footer__268PT","FooterColumn":"Footer__FooterColumn__1uyGs","FooterItem":"Footer__FooterItem__1-u0B","FooterCopyRight":"Footer__FooterCopyRight__2Sf45"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.css
// module id = 380
// module chunks = 0